// An <img> for a picture that sits behind the API's auth.
//
// Every /api route requires an Authorization header, and a plain <img src>
// cannot send one — the browser just gets a 401 and shows a broken image.
// So the bytes are fetched through the api client (which attaches the token)
// and handed to the tag as an object URL.
//
// Object URLs are revoked on unmount and whenever the src changes; without
// that, a grid of camera views would hold every image it has ever shown in
// memory for as long as the page is open.
import React, { useState, useEffect } from 'react';
import api from '../api';

export default function AuthImg({ src, alt = '', fallback = null, style, className, ...rest }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = false;
    let objectUrl = null;
    setUrl(null); setFailed(false);
    if (!src) return undefined;

    api.get(src, { responseType: 'blob' })
      .then(r => {
        if (revoked) return;            // unmounted while the request was in flight
        objectUrl = URL.createObjectURL(r.data);
        setUrl(objectUrl);
      })
      .catch(() => { if (!revoked) setFailed(true); });

    return () => {
      revoked = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (failed) return fallback;
  // Holds the layout while loading, so a grid does not jump as images arrive.
  if (!url) return <div className={className} style={{ ...style, background: 'var(--bg3)' }} />;
  return <img src={url} alt={alt} style={style} className={className} {...rest} />;
}
